/* ABD Bundle Selector — app-free Shopify Ajax API integration. */
(() => {
  'use strict';
  function setup(root) {
    if (root.dataset.abdReady === 'true') return;
    const section = root.closest('product-info');
    const productFormElement = section && section.querySelector('product-form');
    const form = productFormElement && productFormElement.querySelector('form[data-type="add-to-cart-form"]');
    const button = form && form.querySelector('button[name="add"]');
    if (!form || !button) return;
    root.dataset.abdReady = 'true';
    const label = button.querySelector('span');
    const initialLabel = label ? label.textContent.trim() : root.dataset.defaultLabel || 'Add to cart';
    const getRadios = () => Array.from(root.querySelectorAll('.abd-bundle__radio'));
    const errorNode = root.querySelector('[data-abd-error]');
    let busy = false;
    const current = () => getRadios().find(radio => radio.checked) || getRadios()[0];
    function sync() {
      const selected = current();
      if (!selected) return;
      getRadios().forEach(radio => radio.closest('.abd-bundle__tier').classList.toggle('is-selected', radio === selected));
      const size = Number(selected.value);
      const buttonText = size > 1 ? `Add ${size} to cart` : initialLabel;
      if (label && !busy && !button.disabled) label.textContent = buttonText;
      section.dispatchEvent(new CustomEvent('abd:bundle-change', {bubbles:true, detail:{
        size, buttonText, price:selected.dataset.price, compare:selected.dataset.compare || '',
        productName: section.querySelector('.product__title h1')?.textContent?.trim() || '',
      }}));
    }
    root.addEventListener('change', event => {
      if (event.target.matches('.abd-bundle__radio')) sync();
    });
    root.addEventListener('abd:auto-ready', sync);
    // Capturing on the FORM prevents Refresh's product-form custom element from intercepting bundle submissions.
    // One-product tier passes through unchanged to original Refresh code.
    form.addEventListener('submit', async event => {
      const tier = current();
      if (!tier || tier.value === '1') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      const ids = tier.dataset.ids.split(',').map(id => Number(id.trim()));
      const selectedVariant = Number(form.querySelector('input[name="id"]')?.value || root.dataset.primaryVariant);
      if (selectedVariant) ids[0] = selectedVariant;
      const isValid = ids.length === Number(tier.value) && ids.every(Number.isSafeInteger) && new Set(ids).size === ids.length;
      if (!isValid) {
        errorNode.textContent = 'This bundle is temporarily unavailable. Please select another offer.';
        errorNode.hidden = false;
        return;
      }
      const items = ids.map(id => ({ id, quantity:1 }));
      busy = true;
      errorNode.hidden = true;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      try {
        const response = await fetch(root.dataset.cartAddUrl, {
          method:'POST', credentials:'same-origin',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' },
          body:JSON.stringify({items})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw Error(result.description || result.message || 'Could not add the bundle.');
        // Navigating to cart ensures quantities and checkout-priced discounts display correctly, including automatic discounts.
        // We intentionally use cart navigation rather than attempting to manually patch Refresh's cart drawer sections.
        window.location.assign(root.dataset.cartUrl);
      } catch(error) {
        errorNode.textContent = error.message || 'Unable to add the bundle. Please retry.';
        errorNode.hidden = false;
        errorNode.scrollIntoView({block:'nearest', behavior:'smooth'});
      } finally {
        busy = false;
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        sync();
      }
    }, true);
    sync();
  }
  function scan() { document.querySelectorAll('[data-abd-bundles]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
